<script>
import Swal from "sweetalert2";
import { cloneDeep } from "lodash";
import { Carousel, Slide } from "vue-carousel";
import createNumberMask from "text-mask-addons/dist/createNumberMask";
import Campus from "@/components/modals/campus.vue";
import Building from "@/components/modals/property-locationBuildings.vue";
import PrintOptions from "@/components/modals/print-options.vue";
import WarehouseArea from "@/router/views/property/settings-template/warehouse-component/area.vue";

export default {
  components: {
    Campus,
    Building,
    PrintOptions,
    WarehouseArea
  },
  props: {
    selectedCampus: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      quantityMask: createNumberMask({
        prefix: "",
        includeThousandsSeparator: false
      }),
      submitted: false,
      campusSelect: "",
      campusList: ["Show All"],
      tableData: [],
      modalTitle: "",
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: "",
      filterLocation: "",
      sortDesc: false,
      fields: [
        {
          key: "buildingName",
          sortable: true,
          tdClass: "align-middle"
        },
        {
          key: "buildingLocation",
          thStyle: { width: "200px" },
          label: `${this.GLOBAL_FROM_SCHOOL ? "Campus" : "Main Office"}`,
          sortable: true,
          tdClass: "align-middle"
        },
        {
          key: "buildingDescription",
          thStyle: { width: "250px" },
          sortable: true,
          tdClass: "align-middle"
        },
        {
          key: "actions",
          thStyle: { width: "90px" },
          tdClass: "align-middle"
        }
      ],
      fieldsLocation: [
        {
          key: "id",
          sortable: true,
          tdClass: "align-middle",
          thStyle: { width: "100px" }
        },
        {
          key: "location",
          sortable: true,
          tdClass: "align-middle"
        },
        {
          key: "locationCode",
          thStyle: { width: "200px" },
          sortable: true,
          tdClass: "align-middle"
        },
        {
          key: "floorNumber",
          thStyle: { width: "130px" },
          tdClass: "align-middle"
        },
        {
          key: "roomNumber",
          thStyle: { width: "130px" },
          tdClass: "align-middle"
        },
        {
          key: "actions",
          thStyle: { width: "90px" },
          tdClass: "align-middle"
        }
      ],
      fieldsArea: [
        {
          key: "area",
          sortable: true,
          tdClass: "align-middle"
        }
      ],
      locations: null,
      area: null,
      formArea: {
        propertyLocationId: 0,
        parentLocationAreaId: 0,
        areaName: "",
        areaDescription: ""
      },
      building: "",
      campus: "",
      buildingIndex: -1,
      locationIndex: -1,
      areaIndex: -1,
      selectedArea: null,
      tableBusy: false,
      filterLocationSelect: "1",
      carouselPage: 0
    };
  },
  computed: {
    filtered() {
      let data = this.tableData;
      if (this.campusSelect && this.campusSelect != "Show All") {
        data = data.filter((item) => {
          if (
            item.buildingLocation
              .toUpperCase()
              .includes(this.campusSelect.toUpperCase())
          ) {
            return item.buildingLocation
              .toUpperCase()
              .includes(this.campusSelect.toUpperCase());
          }
        });
      }

      if (this.filter.trim() != "" && this.filter) {
        data = data.filter((item) => {
          if (
            item.buildingName.toUpperCase().includes(this.filter.toUpperCase())
          ) {
            return item.buildingName
              .toUpperCase()
              .includes(this.filter.toUpperCase());
          } else if (
            item.buildingDescription
              .toUpperCase()
              .includes(this.filter.toUpperCase())
          ) {
            return item.buildingDescription
              .toUpperCase()
              .includes(this.filter.toUpperCase());
          }
        });
      }
      return data;
    },
    rows() {
      if (this.filter.trim() != "" && this.filter) {
        return this.filtered.length;
      } else {
        return this.tableData.length;
      }
    },
    filteredLocation() {
      let array = this.locations.locations;
      if (this.filterLocationSelect != "1") {
        array = array.filter((item) => {
          if (this.filterLocationSelect == "2") {
            return !item.isWarehouse;
          } else if (this.filterLocationSelect == "3") {
            return item.isWarehouse;
          }
        });
      }

      let keyword = this.filterLocation;
      const regExp = new RegExp(keyword, "gi");
      const check = (obj) => {
        if (obj !== null && typeof obj === "object") {
          return Object.values(obj).some(check);
        }
        if (Array.isArray(obj)) {
          return obj.some(check);
        }
        return (
          (typeof obj === "string" || typeof obj === "number") &&
          regExp.test(obj)
        );
      };
      return array.filter(check);
    },
    rowsLocation() {
      if (this.filterLocation.trim() != "" && this.filterLocation) {
        return this.filteredLocation.length;
      } else {
        return this.locations.locations.length;
      }
    }
  },
  created() {
    this.getData();
  },
  methods: {
    async getData() {
      if (this.selectedCampus) {
        this.getPreviousPage("building");
        this.tableBusy = true;
        this.$store
          .dispatch(
            "propertywarehouse/GetWarehouseBuilding",
            this.selectedCampus
          )
          .then((res) => {
            this.tableBusy = false;
            if (res.data.error) {
              return this.showToast(res.data.errorMessage, "error");
            }
            res.data.forEach((item) => {
              if (
                item.buildingLocation != "" &&
                !this.campusList.includes(item.buildingLocation)
              )
                this.campusList.push(item.buildingLocation);
              item.currentPage = 1;
              item.perPage = 10;
              item.tableBusy = false;
              item.locations = [];
            });
            this.campusSelect = this.campusList[0];
            this.tableData = res.data;
          })
          .catch(() => {
            this.tableBusy = false;
            return this.showToast(
              "Something went wrong - getting location list!",
              "error"
            );
          });
      }
    },
    async getLocation() {
      this.locations.tableBusy = true;
      this.locations.currentPage = 1;
      this.locations.perPage = 10;
      this.filterLocation = "";
      this.locations.locations = [];
      this.$store
        .dispatch("propertywarehouse/GetWarehouseLocation", this.locations.id)
        .then((res) => {
          if (res.data.error) {
            return this.showToast(res.data.errorMessage, "error");
          }
          this.locations.locations = res.data;
          this.locations.tableBusy = false;
          this.$forceUpdate();
        })
        .catch(() => {
          this.locations.tableBusy = false;
          return this.showToast(
            "Something went wrong - getting location list!",
            "error"
          );
        });
    },
    async getArea() {
      this.area.tableBusy = true;
      this.area.areas = [];
      this.$store
        .dispatch(
          "propertywarehouse/GetLocationAreaByLocation",
          this.area.location.id
        )
        .then((res) => {
          if (res.data.error) {
            return this.showToast(res.data.errorMessage, "error");
          }
          res.data.forEach((area) => {
            area.areaChildren = [];
            area.itemVisible = false;
          });
          this.area.areas = res.data;
          this.area.tableBusy = false;
          this.$forceUpdate();
        })
        .catch(() => {
          this.area.tableBusy = false;
          return this.showToast(
            "Something went wrong - getting location list!",
            "error"
          );
        });
    },
    async getNextPage(page, row) {
      if (page == "location") {
        this.carouselPage = 1;
        this.locations = cloneDeep(row);
        this.$nextTick(() => {
          this.getLocation();
          this.$forceUpdate();
        });
      } else if (page == "warehouse") {
        this.carouselPage = 2;
        this.area = {
          location: cloneDeep(row),
          areas: [],
          tableBusy: false
        };
        this.$nextTick(() => {
          this.getArea();
          this.$forceUpdate();
        });
      }
    },
    getPreviousPage(page) {
      if (page == "building") {
        this.carouselPage = 0;
        this.locations = null;
      } else if (page == "location") {
        this.carouselPage = 1;
        this.area = null;
      }
    },
    onCreateArea() {
      this.submitted = true;
      if (
        this.formArea.areaName == "" ||
        this.formArea.areaName == null ||
        this.formArea.areaDescription == "" ||
        this.formArea.areaDescription == null
      ) {
        return;
      } else {
        if (this.formArea.id > 0) {
          this.$store
            .dispatch("propertywarehouse/UpdateLocationArea", this.formArea)
            .then((res) => {
              if (!this.selectedArea) {
                this.area.areas.splice(this.areaIndex, 1, this.formArea);
              } else {
                this.selectedArea.areaChildren.splice(
                  this.areaIndex,
                  1,
                  this.formArea
                );
              }
              this.$bvModal.hide("area-modal");
              return this.showToast("Successfully updated!", "success");
            })
            .catch((err) => {
              return this.showToast(
                "Something went wrong - updating area!",
                "error"
              );
            });
        } else {
          this.$store
            .dispatch("propertywarehouse/CreateLocationArea", this.formArea)
            .then((res) => {
              res.data.areaChildren = [];
              res.data.itemVisible = false;
              if (!this.selectedArea) {
                this.area.areas.push(res.data);
              } else {
                this.selectedArea.areaChildren.push(res.data);
                this.selectedArea.withChild = true;
              }
              this.$bvModal.hide("area-modal");
              return this.showToast("Successfully created!", "success");
            })
            .catch((err) => {
              return this.showToast(
                "Something went wrong - creating area!",
                "error"
              );
            });
        }
        this.submitted = false;
      }
    },
    addArea(props) {
      this.onReset();
      if (props) {
        this.selectedArea = props;
        this.formArea.parentLocationAreaId = props.id;
      } else {
        this.formArea.propertyLocationId = this.area.location.id;
      }
      this.modalTitle = "Create New Area";
      this.$bvModal.show("area-modal");
    },
    updateArea(props) {
      this.onReset();
      if (!props.parentRow) {
        this.areaIndex = this.area.areas.findIndex(
          (item) => item.id == props.areaRow.id
        );
      } else {
        this.selectedArea = props.parentRow;
        this.areaIndex = props.parentRow.areaChildren.findIndex(
          (item) => item.id == props.areaRow.id
        );
      }
      this.formArea = cloneDeep(props.areaRow);
      this.modalTitle = "Update Location";
      this.$bvModal.show("area-modal");
    },
    deleteArea(props) {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#dc3545",
        cancelButtonColor: "#5c636a",
        confirmButtonText: "Yes, delete it!"
      }).then((result) => {
        if (result.value) {
          this.$store
            .dispatch("propertywarehouse/DeleteLocationArea", props.areaRow.id)
            .then((res) => {
              if (res.data.error) {
                return this.showToast(res.data.errorMessage, "error");
              }
              if (!props.parentRow) {
                this.areaIndex = this.area.areas.findIndex(
                  (item) => item.id == props.areaRow.id
                );
                this.area.areas.splice(this.areaIndex, 1);
              } else {
                this.areaIndex = props.parentRow.areaChildren.findIndex(
                  (item) => item.id == props.areaRow.id
                );
                props.parentRow.areaChildren.splice(this.areaIndex, 1);
                if (props.parentRow.areaChildren.length == 0) {
                  props.parentRow.withChild = false;
                  props.parentRow.itemVisible = false;
                }
              }
              return this.showToast("Successfully deleted", "success");
            })
            .catch((err) => {
              return this.showToast("Cannot be deleted!", "error");
            });
        }
      });
    },
    onReset() {
      this.submitted = false;
      this.formArea = {
        propertyLocationId: 0,
        parentLocationAreaId: 0,
        areaName: "",
        areaDescription: ""
      };
      this.selectedArea = null;
      this.building = "";
      this.campus = "";
    }
  }
};
</script>

<template>
  <div>
    <!-- Create / Update Area -->
    <b-modal
      id="area-modal"
      :title="modalTitle"
      size="md"
      title-class="font-18"
      hide-footer
      no-close-on-backdrop
    >
      <form
        @submit.prevent="onCreateArea"
        class="needs-validation"
        ref="accForm"
      >
        <div class="mb-3">
          <label for="location">Area </label>
          <input
            autocomplete="off"
            id="location"
            type="text"
            v-model="formArea.areaName"
            placeholder="Enter Area..."
            class="form-control"
            :class="{
              'is-invalid':
                submitted &&
                (formArea.areaName == '' || formArea.areaName == null)
            }"
          />
          <div
            v-if="
              submitted &&
                (formArea.areaName == '' || formArea.areaName == null)
            "
            class="invalid-feedback"
          >
            <span>This value is required.</span>
          </div>
        </div>
        <div class="mb-3">
          <label for="location">Description </label>
          <textarea
            id="remarks"
            rows="3"
            v-model="formArea.areaDescription"
            placeholder="Enter Description..."
            class="form-control"
            :class="{
              'is-invalid':
                submitted &&
                (formArea.areaDescription == '' ||
                  formArea.areaDescription == null)
            }"
            autocomplete="off"
          ></textarea>
          <div
            v-if="
              submitted &&
                (formArea.areaDescription == '' ||
                  formArea.areaDescription == null)
            "
            class="invalid-feedback"
          >
            <span>This value is required.</span>
          </div>
        </div>
        <div class="d-flex justify-content-end">
          <button type="submit" class="btn btn-primary">
            {{ formArea.id > 0 ? "Update" : "Create" }}
          </button>
        </div>
      </form>
    </b-modal>
    <!-- Main -->
    <transition name="slide">
      <div v-if="carouselPage == 0">
        <div class="card border">
          <div class="card-body">
            <div class="row mt-1 mb-3">
              <div class="col-sm-12 col-md-6">
                <div class="d-flex align-items-center h-100">
                  <h5 class="mb-0">Building List</h5>
                </div>
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-6">
                <b-form-select
                  class="form-select w-50"
                  v-model="campusSelect"
                  :options="campusList"
                ></b-form-select>
              </div>
              <div class="col-6">
                <label class="d-flex align-items-center">
                  <b-form-input
                    autocomplete="off"
                    v-model="filter"
                    type="search"
                    placeholder="Search building..."
                    class="form-control mx-2 w-75"
                  ></b-form-input>
                  <b-form-select
                    class="form-select w-25"
                    v-model="perPage"
                    :options="pageOptions"
                  ></b-form-select>
                </label>
              </div>
            </div>
            <div class="table-responsive mb-0">
              <b-table
                class="datatables"
                :items="filtered"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                sort-by="buildingLocation"
                :sort-desc.sync="sortDesc"
                :busy="tableBusy"
                bordered
                outlined
                striped
                show-empty
              >
                <template #empty>
                  <div class="text-center">
                    <div>
                      <i class="fas fa-exclamation-triangle me-2"></i>No Data
                      Found
                    </div>
                  </div>
                </template>
                <template #table-busy>
                  <div class="d-flex justify-content-center align-items-center">
                    <div class="preloader-component me-2">
                      <div class="status">
                        <div class="spinner-chase w-20px h-20px">
                          <div class="chase-dot"></div>
                          <div class="chase-dot"></div>
                          <div class="chase-dot"></div>
                          <div class="chase-dot"></div>
                          <div class="chase-dot"></div>
                          <div class="chase-dot"></div>
                        </div>
                      </div>
                    </div>
                    <strong>Loading...</strong>
                  </div>
                </template>
                <template #cell(actions)="row">
                  <div
                    class="d-flex justify-content-between align-items-center"
                  >
                    <div class="font-size-12" style="width: max-content">
                      <a
                        href="javascript: void(0);"
                        class="text-info d-flex align-items-center"
                        @click="getNextPage('location', row.item)"
                      >
                        View Locations
                        <i class="bx bx-chevron-right rotate font-size-14"></i>
                      </a>
                    </div>
                  </div>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else-if="carouselPage == 1 && locations">
        <div class="card border">
          <div class="card-body">
            <div class="row mt-1 mb-3">
              <div class="col-sm-12 col-md-6">
                <div class="d-flex align-items-center h-100">
                  <a
                    href="javascript:void(0);"
                    class="d-flex align-items-center"
                    @click="getPreviousPage('building')"
                    ><i class="bx bx-left-arrow-alt fs-2 me-1"></i>
                    <h5 class="m-0">Location List</h5>
                  </a>
                </div>
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-6">
                <b-form-select
                  class="form-select w-50"
                  v-model="filterLocationSelect"
                >
                  <option value="1">Show All</option>
                  <option value="2">Location</option>
                  <option value="3">Warehouse</option>
                </b-form-select>
              </div>
              <div class="col-6">
                <label class="d-flex align-items-center">
                  <b-form-input
                    autocomplete="off"
                    v-model="filterLocation"
                    type="search"
                    placeholder="Search location..."
                    class="form-control mx-2 w-75"
                  ></b-form-input>
                  <b-form-select
                    class="form-select w-25"
                    v-model="locations.perPage"
                    :options="pageOptions"
                  ></b-form-select>
                </label>
              </div>
            </div>
            <div class="table-responsive mb-0">
              <b-table
                class="datatables"
                :items="filteredLocation"
                :fields="fieldsLocation"
                responsive="sm"
                :per-page="locations.perPage"
                :current-page="locations.currentPage"
                sort-by="id"
                :sort-desc.sync="sortDesc"
                :busy="locations.tableBusy"
                bordered
                outlined
                striped
                show-empty
              >
                <template #empty>
                  <div class="text-center">
                    <div>
                      <i class="fas fa-exclamation-triangle me-2"></i>No Data
                      Found
                    </div>
                  </div>
                </template>
                <template #table-busy>
                  <div class="d-flex justify-content-center align-items-center">
                    <div class="preloader-component me-2">
                      <div class="status">
                        <div class="spinner-chase w-20px h-20px">
                          <div class="chase-dot"></div>
                          <div class="chase-dot"></div>
                          <div class="chase-dot"></div>
                          <div class="chase-dot"></div>
                          <div class="chase-dot"></div>
                          <div class="chase-dot"></div>
                        </div>
                      </div>
                    </div>
                    <strong>Loading...</strong>
                  </div>
                </template>
                <template #cell(actions)="row">
                  <div
                    class="d-flex justify-content-between align-items-center"
                  >
                    <div class="font-size-12" style="width: max-content">
                      <a
                        v-if="row.item.isWarehouse"
                        href="javascript: void(0);"
                        class="text-info d-flex align-items-center"
                        @click="getNextPage('warehouse', row.item)"
                      >
                        View Warehouse
                        <i class="bx bx-chevron-right rotate font-size-14"></i>
                      </a>
                    </div>
                  </div>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination
                      v-model="locations.currentPage"
                      :total-rows="rowsLocation"
                      :per-page="locations.perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else-if="carouselPage == 2 && area">
        <div class="card border">
          <div class="card-body">
            <div class="row mt-1 mb-3">
              <div class="col-sm-12 col-md-6">
                <div class="d-flex align-items-center h-100">
                  <a
                    href="javascript:void(0);"
                    class="d-flex align-items-center"
                    @click="getPreviousPage('location')"
                    ><i class="bx bx-left-arrow-alt fs-2 me-1"></i>
                    <h5 class="m-0">Warehouse</h5>
                  </a>
                </div>
              </div>
              <div class="col-sm-12 col-md-6">
                <div class="d-flex justify-content-end align-items-center">
                  <button
                    type="button"
                    @click="addArea()"
                    class="ms-2 btn btn-sm btn-info d-flex align-items-center"
                  >
                    <i class="bx bx-plus me-2 fs-6"></i>Create New
                  </button>
                </div>
              </div>
            </div>
            <div class="custom-table-responsive mb-0 mt-2">
              <b-card-header v-if="area.tableBusy">
                <div class="d-flex justify-content-center align-items-center">
                  <div class="preloader-component me-2">
                    <div class="status">
                      <div class="spinner-chase w-20px h-20px">
                        <div class="chase-dot"></div>
                        <div class="chase-dot"></div>
                        <div class="chase-dot"></div>
                        <div class="chase-dot"></div>
                        <div class="chase-dot"></div>
                        <div class="chase-dot"></div>
                      </div>
                    </div>
                  </div>
                  <strong>Loading...</strong>
                </div>
              </b-card-header>
              <b-card-header v-else-if="!area || area.areas.length == 0">
                <div class="text-center">
                  <i class="fas fa-exclamation-triangle me-2"></i>No warehouse
                  locations available
                </div>
              </b-card-header>
              <div v-for="areaRow in area.areas" :key="areaRow.id">
                <warehouse-area
                  ref="warehouseArea"
                  :areaRow="areaRow"
                  @addArea="addArea($event)"
                  @updateArea="updateArea($event)"
                  @deleteArea="deleteArea($event)"
                ></warehouse-area>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <Campus ref="campus" @dropData="dropCampus($event)"></Campus>
    <Building ref="building" @dropData="dropBuilding($event)"></Building>
    <print-options ref="printOpt"></print-options>
  </div>
</template>

<style>
.propertyTable tr td {
  padding: 0 !important;
  margin: 0 !important;
}

.slide-enter-active {
  animation: slide-in 0.25s;
}

.slide-leave-active {
  animation: slide-in 0.25s reverse;
}

@keyframes slide-in {
  0% {
    transform: translateX(-20px);
    opacity: 0;
  }

  100% {
    transform: translateX(0);
    opacity: 1;
  }
}
</style>
